module.exports = __webpack_public_path__ + "static/media/secure-payments.bca6e7e3.svg";